import { benefits } from "@/mocks/hoobuyData";

export default function BenefitsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
            Por Que Escolher Nosso Hoobuy Spreadsheet?
          </h2>
          <p className="mt-3 text-base text-foreground-500 max-w-[600px] mx-auto">
            A ferramenta mais completa para compradores brasileiros encontrarem produtos de qualidade
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5 max-w-[1100px] mx-auto">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="text-center p-5 rounded-lg bg-background-100 border border-background-200/70"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${benefit.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 text-sm font-bold font-heading text-foreground-950">
                {benefit.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}